<template>
  <div class="absolute bottom-0 left-0">
    <ul class="p-1 flex box-2" v-if="usersOnline.length">
      <li
        v-for="(userOnline, index) in usersOnline.slice(0, 4)"
        :key="index"
        v-tooltip.bottom-start="collaboratorTooltip(userOnline)"
        class="presenter-avatar"
      >
        <aha-avatar
          v-if="userOnline && userOnline.user"
          :name="userOnline.user.firstName"
          :image="userOnline.user.avatar"
          :id="userOnline.user.id"
          class="avatar"
        />
      </li>
      <!-- <li
        class="cursor-pointer presenter-avatar more"
        v-if="usersOnline.length > 1"
      >
        +{{ usersOnline.length - 1 }}
      </li> -->
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'UserEditSlide',
  props: {
    usersOnline: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
  },
  methods: {
    formatName(userOnline) {
      let name = userOnline.user.firstName
      if (userOnline.user.lastName) {
        name += ` ${userOnline.user.lastName}`
      }
      return name
    },
    collaboratorTooltip(userOnline) {
      if (!userOnline || !userOnline.user || !this.currentUser.id) return ''
      let role = 'Viewing'
      let textForMyData = ''
      if (userOnline.isCanEdit) {
        role = 'Editing'
      }
      if (userOnline.user.id === this.currentUser.id) {
        textForMyData = ' (you)'
      }
      return `<div class="text-center"><strong>${this.formatName(userOnline)}</strong>${textForMyData} </br> ${role}<div>`
    },
  },
}
</script>

<style lang="scss" scoped>
 .presenter-avatar {
    @apply w-7 h-7 rounded-full text-center;
    line-height: 26px;
    margin-right: -5px;

    .avatar {
      border: 1px solid #FFFFFF;
      font-size: 10px;
      font-weight: bold;
    }

    &:nth-child(1) {
      z-index: 4;
    }
    &:nth-child(2) {
      z-index: 3;
    }
    &:nth-child(3) {
      z-index: 2;
    }
    &:nth-child(4) {
      z-index: 1;
    }

    &:last-child {
      margin-right: 5px;
    }

    &.more {
      @apply bg-secondary-50 text-base-0;
      font-size: 10px;
      font-weight: bold
    }
  }
</style>
